import type { FeedbackRequest } from '@/types/feedback-types';
import ApiService from './api-services';

class FeedbackService extends ApiService {
  constructor() {
    super('/feedback');
  }

  async createFeedback(feedback: FeedbackRequest) {
    const data: any = {
      rating: feedback.rating,
    };

    if (feedback.email) {
      data.email = feedback.email;
    }
    if (feedback.whatIsLoved && feedback.whatIsLoved.length > 0) {
      data.what_is_loved = feedback.whatIsLoved;
    }
    if (feedback.whatToImprove && feedback.whatToImprove.length > 0) {
      data.what_to_improve = feedback.whatToImprove;
    }

    return this.postData('', data);
  }
}

export default new FeedbackService();
